<template>
    <div class="view-tasklists">
        <user-menu />
        <div class="wrapper">
            <masteradmin-sidebar-menu />
            <div class="content-wrapper">
                <div class="container-wrapper center">
                    <div>
                        <h3 class="d-inline heading">Course Display</h3>
                       
                    </div>
                    <div class="heading-seperator"></div>
                    <div class="margin-bottom-10"></div>

                <div id="learnembed" class="pacificblue">
                  <VueScriptComponent script='<script type="text/javascript">var user_id = document.getElementById("userIdWrapper").innerText; var partner_id = 146;var language_id = 1;var dashboard_path = document.getElementById("pathWrapper").innerText;</script><script id="course" charset="utf-8" src="https://courses.mentoringsandbox.com/products/lea/embed/course/embed_course.js"></script>' />           
                </div>
                   
                </div>   

            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import { store } from '../../store/store';
import router from '../../router/index.js';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';
import VueScriptComponent from 'vue-script-component'

export default {
    data() {
        return {            
            courseUrl: '',
        }
    },
    components: {
        UserMenu,        
        MasteradminSidebarMenu, 
        VueScriptComponent,       
    },
    methods: {
        
    },    
    created() {
      this.courseUrl = process.env.MM_COURSE_URL + 'products/learn/embed/course/embed_course.js';
    },
    
}
</script>
<style scoped>
.dropdown {
  position: absolute;
  display: inline-block;
  right: 1.4em;
}
.edit-action-btn {
  width: 70px;
  margin-right: 5px;
}
.deactivate-btn {
  width: 83px;
  margin-right: 5px;
}
.preview-wrapper {
  padding-right: 10px;
}
.btn-dark-grey, .btn-dark-grey:hover, .btn-dark-grey:focus {
  background-color: #555;
  color: #FFF;
  border: 1px solid #555;
}
.space-wrapper {
  padding-right: 10px;
}
.tasks_heading_row {
  background-color: #8b8b8b;
  line-height: 25px;
  color: #FFF;
  padding: 3px 0px;
  margin-right: 0px;
  margin-left: 0px;
}
*, *::before, *::after {
  outline: none;
}
.input-height-30 {
  line-height: 30px;
}
.naics-code-wrapper {
  padding-left: 15px;
}
hr {
  border-top: 2px solid #8b8b8b;
  margin: 0px;
}
.tasklist-row:nth-of-type(odd) {
  background-color:#fff;
}
.tasklist-row:nth-of-type(even) {
  background-color:#e9e9e9;
}
.search-wrapper {
  background-color: transparent;
}
.heading-seperator {
  border-bottom: 2px solid #00ACEE;
}
.btn-blue {
  background-color: #dc2227 !important;
  border: 1px solid #dc2227 !important;
}
.create-btn {
    line-height: 15px;
    font-weight: bold;
    font-size: 13px;
}
.heading {
  font-size: 15px;
}
.tasklist-item {
  padding: 8px 0px 8px 0px;
}
.package-name {
  padding-left: 20px;
}
#manage-link {
  color: #00ACEE;
  text-decoration: underline; 
}
</style>



// WEBPACK FOOTER //
// src/components/admin/course_render.vue